import { Download, ScanLine, ShieldCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "@/i18n";

const QR_IMG = "https://connected-center-basra.aglowspark17.chatgpt.site/showroom/warranty-qr.jpg";

export default function Warranty() {
  const { t } = useLang();
  return (
    <section id="warranty" data-testid="warranty-section" className="relative py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <p className="mb-3 flex items-center gap-3 text-xs font-bold tracking-[0.25em] text-[#E3AF4F]">
            <span className="h-px w-10 bg-[#E3AF4F]" />
            {t.warranty.eyebrow}
          </p>
          <h2 className="font-heading text-2xl font-bold leading-snug text-[#F5F2EB] sm:text-3xl lg:text-4xl">
            {t.warranty.headingA} <span className="text-gold-grad">{t.warranty.headingB}</span>
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-[#A8A29E]">
            {t.warranty.paragraph}
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <a
              href="https://5aegis.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="warranty-verify-button"
              className="inline-flex items-center gap-2 rounded-full bg-[#E3AF4F] px-8 py-3.5 text-sm font-bold text-[#000000] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#F5D08C] hover:shadow-lg hover:shadow-[#E3AF4F]/25"
            >
              <ShieldCheck size={16} />
              {t.warranty.verify}
            </a>
            <a
              href={QR_IMG}
              download
              target="_blank"
              rel="noopener noreferrer"
              data-testid="warranty-download-button"
              className="inline-flex items-center gap-2 rounded-full border border-[#E3AF4F]/40 px-8 py-3.5 text-sm font-bold text-[#E3AF4F] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#E3AF4F]/10"
            >
              <Download size={16} />
              {t.warranty.save}
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="relative mx-auto max-w-sm">
            <div
              className="pointer-events-none absolute -inset-6 rounded-[2.5rem] border border-[#E3AF4F]/20"
              aria-hidden="true"
            />
            <a
              href="https://5aegis.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="warranty-qr-link"
              className="block overflow-hidden rounded-3xl border border-[#F5F2EB]/10 bg-[#0E0E0E] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#E3AF4F]/50"
            >
              <img
                src={QR_IMG}
                alt={t.warranty.qrAlt}
                loading="lazy"
                data-testid="warranty-qr-image"
                className="w-full rounded-2xl"
              />
              <p className="mt-5 flex items-center justify-center gap-2 text-center text-xs text-[#A8A29E]">
                <ScanLine size={14} className="shrink-0 text-[#E3AF4F]" />
                {t.warranty.qrCaption}
              </p>
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
